import { useEffect, useState } from "react";
import styles from "./SelectFilter.module.scss";
import { FormControl, MenuItem, Select, useMediaQuery } from "@mui/material";
import { DataGridFilterValues, DataGridHeaders } from "@/models/datagrid";

type Props = {
    setParams: (params: any) => void;
    values?: Array<DataGridFilterValues>;
    header: DataGridHeaders;
    initialParams?: any[];
};

const SelectFilter = ({ header, setParams, values, initialParams }: Props) => {
    const { field, filterOptions } = header;
    const isMobile = useMediaQuery("(max-width: 768px)");

    const selectedValue = values?.find((value) => value.columnField === field)?.value;

    const [selectValue, setSelectValue] = useState(selectedValue || "");

    const onChangeSelect = ({ target: { value } }) => {
        setSelectValue(value);

        setParams((prevParams) => {
            const others = prevParams?.customFilterModel?.items.filter((i) => i.columnField !== field) || [];
            // The empty option is "All", and it removes the filter rather than
            // filtering on an empty string. Without it a filter could be
            // switched on and never off - pick "Buy" and the sells were gone
            // for good, with no control on screen to bring them back.
            const items = value === "" ? others : [...others, { columnField: field, id: Date.now(), operatorValue: "equals", value }];
            return { ...prevParams, customFilterModel: { items } };
        });
    };

    useEffect(() => setSelectValue(selectedValue || ""), [selectedValue]);

    const formatStringWithUnderscore = (str: string) => {
        if (str.includes("_")) return str.replace(/_/g, " ");
        return str;
    };

    return (
        <FormControl size="small" fullWidth sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
            <Select
                className={styles.select}
                onChange={onChangeSelect}
                size="small"
                value={selectValue || ""}
                displayEmpty
                renderValue={(value) => (value === "" ? "All" : value.toString())}
                MenuProps={isMobile ? { slotProps: { paper: { style: { maxHeight: "90vh" } } } } : {}}
            >
                <MenuItem value="" sx={{ fontSize: "12px", color: "text.secondary" }}>
                    All
                </MenuItem>
                {filterOptions.map((option) => (
                    <MenuItem value={option} sx={{ fontSize: "12px", textTransform: "capitalize" }} key={option}>
                        {formatStringWithUnderscore(option.toString())}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectFilter;
